module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-form', {
    ref: "editForm",
    attrs: {
      "model": _vm.editForm,
      "label-width": "100px",
      "rules": _vm.editFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "信息类型",
      "prop": "info_type"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "400px"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.editForm.info_type),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "info_type", $$v)
      },
      expression: "editForm.info_type"
    }
  }, _vm._l((_vm.infoTypes), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.item_name,
        "value": item.item_value
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "标题",
      "prop": "title"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.title),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "title", $$v)
      },
      expression: "editForm.title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "文章",
      "prop": "content"
    }
  }, [_c('div', {
    staticStyle: {
      "line-height": "0px"
    }
  }, [_c('ueditor', {
    attrs: {
      "value": _vm.value,
      "config": _vm.config
    },
    on: {
      "input": _vm.input,
      "ready": _vm.ready
    }
  })], 1)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "",
      "prop": "click"
    }
  }, [_c('el-checkbox', {
    model: {
      value: (_vm.editForm.click),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "click", $$v)
      },
      expression: "editForm.click"
    }
  }, [_vm._v("单词点击跳转详情页")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editSubmit($event)
      }
    }
  }, [_vm._v("提交")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.backSubmit($event)
      }
    }
  }, [_vm._v("返回")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-2af3eca4"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/views/content/articleedit.vue
// module id = 233
// module chunks = 1